import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
function SelfProject(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br /> 
        <div class="card">
           <div class="card-footer" style={{height:"50px"}}>
            <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('LabCorp')}>Previous</Link></span>
            <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('AnyBerLink')}>Next</Link></span>
           </div>
           <h5 class="card-header">Self Employed (Freelance), Manning, SC
                              <br/>May 2015 – Dec 2015
                              <br/>Stack.Net Developer
           </h5>    					       
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
           -Create a Web-Site as Per Client Requirement
<br />-Work with client direct to Understand the requirement for project
<br />-Create a data structure for application
<br />-Create a UI for entire application using MVC framework
<br />-Created a class library project for client application
<br />-Also created a API for application using rest API
<br />-Use Bootstrap and CSS for UI

            <h3 style={{textDecoration:"underline"}}>Environment</h3>
            Visual Studio 2015/2013,.NET Framework 4.5, Entity Framework 6.0, ASP.NET MVC 5, C#, Angular 2.0, JavaScript, HTML 5, CSS 3, SQL, Microsoft SQL server, Microsoft SQL server management studio, Bootstrap 3.0, 
           </div>            
         </div>
       </div>
       
)
}
export default SelfProject